// // IpGeolocation
// var httpRequest = new XMLHttpRequest();

// httpRequest.onreadystatechange = function() {
//   if (4 === this.readyState && 200 === this.status) {
//     var json = JSON.parse(this.responseText);
//     redirect(json.country_code);
//   }
// }
// httpRequest.open("GET", "https://freegeoip.app/json/", false);
// httpRequest.setRequestHeader("Accept", "application/json");
// httpRequest.send();

// function redirect(country_code) {
//   if ( country_code != "NL" && country_code != "BE" && country_code != "IM" ) {
//     console.log(country_code);
//     //window.location.href = "https://www.talacooking.com/pages/not-available";
//   }
// }

(async () => {
  const result = await fetch("//freegeoip.app/json/");
  const json = await result.json();
  if ( json.country_code != "GB" && json.country_code != "IE" && json.country_code != "IM" && json.country_code != "NL" ) {
    var current_text = document.getElementById("country-message").innerHTML;
    var new_text = current_text.replace('%%',json.country_name);
    document.getElementById("country-message").innerHTML = new_text;
 	document.getElementById("shipping-country-notification").style.display = "block";
  }
})();